module.exports = ".desktop-page-container {\n  width: 100%;\n  height: auto;\n  background-color: #f0f0f0; }\n"